module.exports = __webpack_public_path__ + "static/media/spin-win.b25b0ef6.png";